export const enSeasonMetaDesc = [
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes online, including free & 4K options.',
		v1_max_length: 109,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 114,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes online, including free & 4K options.',
		v1_max_length: 117,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 122,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 152,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes online, including free & 4K options.',
		v1_max_length: 121,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}}. Discover where to watch full episodes, including free and 4K options.',
		v2_max_length: 142,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes online, including free & 4K options.',
		v1_max_length: 127,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}}. See where to watch full episodes, incl free.',
		v2_max_length: 122,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 143,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}}. Find full episodes online, including free & 4K options.',
		v1_max_length: 139,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 146,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 149,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} & 1 other service - watch full episodes online, incl free & 4K options.',
		v1_max_length: 154,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service -  full episodes available.',
		v2_max_length: 136,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} and 1 other service. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				lt: 13,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} & {{restCount}} other services - watch full episodes online, incl free options.',
		v1_max_length: 154,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services - full episodes available.',
		v2_max_length: 139,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} and {{restCount}} other services. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}}  is streaming now on {{providerNames}} - watch every episode online, including free & 4K options.',
		v1_max_length: 119,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 123,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 153,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}}. Watch every episode online, including free & 4K options.',
		v1_max_length: 125,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 131,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 142,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}}. Watch every episode online, including free & 4K options.',
		v1_max_length: 130,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 136,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 146,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}}. Watch every episode online, including free & 4K options.',
		v1_max_length: 135,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 141,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}}. Watch every episode online, including free & 4K options.',
		v1_max_length: 149,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 155,
		v3_translatable:
			'Watch {{titleName}} legally online on {{providerNames}} - full episodes available. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} & 1 other service. Watch every episode online, incl. free & 4K.',
		v1_max_length: 155,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service - full episodes available.',
		v2_max_length: 144,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				lt: 22,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} & {{restCount}} other services - watch full episodes.',
		v1_max_length: 137,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services. Watch every episode online.',
		v2_max_length: 151,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services. Watch full episodes.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch every episode online, including free & 4K options.',
		v1_max_length: 129,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 134,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 153,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch every episode online, including free & 4K options.',
		v1_max_length: 137,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 142,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 143,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch every episode online, including free & 4K options.',
		v1_max_length: 142,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 147,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 147,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch every episode online, including free & 4K options.',
		v1_max_length: 147,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 152,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}}. Streaming options last updated on {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free & 4K options.',
		v1_max_length: 154,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v2_max_length: 137,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 144,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} & 1 other service - watch full episodes, including free & 4K options.',
		v1_max_length: 172,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service - full episodes available.',
		v2_max_length: 155,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service - full episodes available.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 33,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} & {{restCount}} other services - watch full episodes.',
		v1_max_length: 148,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services.',
		v2_max_length: 134,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services - full episodes.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch every episode online, including free & 4K options.',
		v1_max_length: 149,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free & 4K options.',
		v2_max_length: 154,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes. Last updated on {{lastUpdatedAt}}.',
		v3_max_length: 155,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free & 4K options.',
		v1_max_length: 150,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, including free options.',
		v2_max_length: 157,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free & 4K options.',
		v1_max_length: 155,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v2_max_length: 138,
		v3_translatable:
			'Watch {{titleName}} legally online on {{providerNames}} - full episodes. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable: '{{titleName}} is streaming now on {{providerNames}} - watch full episodes online.',
		v1_max_length: 138,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v2_max_length: 143,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 150,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '{{titleName}} is streaming now on {{providerNames}} - watch full episodes.',
		v1_max_length: 144,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v2_max_length: 157,
		v3_translatable: 'Watch {{titleName}} legally online on {{providerNames}} - full episodes available.',
		v3_max_length: 153,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '{{titleName}} is streaming now on {{providerNames}} & 1 other service.',
		v1_max_length: 141,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service.',
		v2_max_length: 150,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} & 1 other service.',
		v3_max_length: 149,
	},
	{
		conditions: {
			title: {
				lt: 53,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '{{titleName}} is streaming now on {{providerNames}} & {{restCount}} other services.',
		v1_max_length: 147,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services.',
		v2_max_length: 154,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} & {{restCount}} other services.',
		v3_max_length: 154,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 7,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free & 4K options.',
		v1_max_length: 150,
		v2_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available, incl. free options.',
		v2_max_length: 153,
		v3_translatable:
			'Watch {{titleName}} legally online now on {{providerNames}} - full episodes. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 156,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 15,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free options.',
		v1_max_length: 153,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v2_max_length: 141,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}}. Updated: {{lastUpdatedAt}}.',
		v3_max_length: 148,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 21,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free options.',
		v1_max_length: 158,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}}. Find full episodes.',
		v2_max_length: 140,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v3_max_length: 145,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 30,
			},
		},
		v1_translatable:
			'{{titleName}} is streaming now on {{providerNames}} - watch full episodes, including free options.',
		v1_max_length: 163,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - Stream the full episodes.',
		v2_max_length: 152,
		v3_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes available.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				lte: 40,
			},
		},
		v1_translatable: '{{titleName}} is streaming on {{providerNames}} - watch full episodes.',
		v1_max_length: 149,
		v2_translatable: 'Watch {{titleName}} legally online now on {{providerNames}} - full episodes.',
		v2_max_length: 155,
		v3_translatable: 'Watch {{titleName}} legally online on {{providerNames}} - full episodes.',
		v3_max_length: 151,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				eq: 1,
			},
		},
		v1_translatable: '{{titleName}} is streaming now on {{providerNames}} & 1 other service.',
		v1_max_length: 149,
		v2_translatable: 'Watch {{titleName}} legally now on {{providerNames}} & 1 other service.',
		v2_max_length: 156,
		v3_translatable: 'Watch {{titleName}} online now on {{providerNames}} & 1 other service.',
		v3_max_length: 149,
	},
	{
		conditions: {
			title: {
				gt: 52,
			},
			provider: {
				gt: 40,
			},
			restCount: {
				gt: 1,
			},
		},
		v1_translatable: '{{titleName}} is streaming now on {{providerNames}} & {{restCount}} other services.',
		v1_max_length: 155,
		v2_translatable: 'Watch {{titleName}} legally now on {{providerNames}} & {{restCount}} other services.',
		v2_max_length: 156,
		v3_translatable: 'Watch {{titleName}} online on {{providerNames}} & {{restCount}} other services.',
		v3_max_length: 150,
	},
];
